import {action} from 'typesafe-actions';
import {Menu} from '@models/menu';
import {RequestData} from "@models/axios";

export const enum MenusActionTypes {
    FETCH_REQUEST = '@@menus/FETCH_REQUEST',
    FETCH_SUCCESS = '@@menus/FETCH_SUCCESS',
    FETCH_ERROR = '@@menus/FETCH_ERROR',

    DELETE_REQUEST = '@@menus/DELETE_REQUEST',
    DELETE_SUCCESS = '@@menus/DELETE_SUCCESS',
    DELETE_ERROR = '@@menus/DELETE_ERROR',

    CREATE_REQUEST = '@@menus/CREATE_REQUEST',
    CREATE_SUCCESS = '@@menus/CREATE_SUCCESS',
    CREATE_ERROR = '@@menus/CREATE_ERROR',

    UPDATE_REQUEST = '@@menus/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@menus/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@menus/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@menus/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@menus/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@menus/FETCH_ITEM_ERROR"
}


export const fetchRequest = (data: RequestData) => action(MenusActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Menu[]) => action(MenusActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(MenusActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data: RequestData) => action(MenusActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data: RequestData) => action(MenusActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(MenusActionTypes.DELETE_ERROR, message);

export const createRequest = (data: RequestData) => action(MenusActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Menu[]) => action(MenusActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(MenusActionTypes.CREATE_ERROR, message);

export const updateRequest = (data: RequestData) => action(MenusActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Menu[]) => action(MenusActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(MenusActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data: RequestData) => action(MenusActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Menu[]) => action(MenusActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(MenusActionTypes.FETCH_ITEM_ERROR, message);